var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":true,"width":"520px","custom-class":"theme-dialog","title":_vm.question.content.text},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"vote-answer",staticStyle:{"margin-top":"0"}},[_c('choice-vote-content',{attrs:{"items":_vm.items,"show-count":-1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }